import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// CloudWatch RUM starts from the loader snippet in public/index.html, not from
// here — see the comment there for why it is not bundled. The CRA reportWebVitals
// stub that used to sit at the bottom of this file was removed with it: it was
// called with no callback, so it had never emitted anything, and RUM's
// 'performance' telemetry collects the same Core Web Vitals properly.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
